import classNames from 'classnames';
import { useTranslateForm } from 'hooks/use-translate-payoff';
import { useAppSelector } from 'hooks/useAppSelector';
import { ComponentProps } from 'react';
import { useQuote } from 'routes/essential-workspace/hooks/use-quote';
import { selectFormEnrichedSolvingMode } from 'state/selectors';

export function QuoteModes({ className, ...divProps }: ComponentProps<'div'>) {
  const { formId, textColor } = useQuote();
  const solvingMode = useAppSelector(state => selectFormEnrichedSolvingMode(state, formId));

  const { translateFieldLabel } = useTranslateForm();
  const solvingModeLabel = translateFieldLabel(solvingMode);

  return (
    <div className={classNames('d-grid gap-2 flex-grow-1 text-start', textColor, className)} {...divProps}>
      <span className="h5 lh-1 mb-0">{solvingModeLabel}</span>
    </div>
  );
}
